import Availability from "./Availability";
import Features from "./Features";
import Main from "./Main";
import Overlay from "../Overlay";

export default function Subscriptions() {
  return (
    <>
      <Main />
      <Availability />
      <Features />
      <Overlay />
    </>
  );
}
